const ACTIONS = {
    SET_CURRENT_NODE: "SET_CURRENT_NODE",
}

export default ACTIONS;